import { useEffect } from 'react'
import { FiAlertTriangle, FiTrash2, FiXCircle } from 'react-icons/fi'
import './ConfirmDeleteModal.css'

function ConfirmDeleteModal({ modalStatus, changeStatus, onConfirm, title, message, itemName, confirmText, confirmIcon: ConfirmIcon }) {
    useEffect(() => {
        if (!modalStatus) return
        const onKey = (e) => { if (e.key === 'Escape') changeStatus(false) }
        document.addEventListener('keydown', onKey)
        return () => document.removeEventListener('keydown', onKey)
    }, [modalStatus, changeStatus])

    if (!modalStatus) return null

    return (
        <div className="cdm-overlay" onClick={() => changeStatus(false)}>
            <div className="cdm-box" onClick={(e) => e.stopPropagation()}>
                <button type="button" className="cdm-close shd-modal-close" onClick={() => changeStatus(false)}>X</button>
                <div className="cdm-icon"><FiAlertTriangle size={22} /></div>
                <p className="cdm-title">{title || 'Confirmar exclusão'}</p>
                <p className="cdm-message">{message || 'Deseja realmente excluir este item?'}</p>
                {itemName && <p className="cdm-item-name">{itemName}</p>}
                <div className="cdm-actions">
                    <button type="button" className="cdm-btn cdm-btn-delete" onClick={onConfirm}>
                        {ConfirmIcon ? <ConfirmIcon size={18} /> : <FiTrash2 size={18} />}<span>{confirmText || 'Apagar'}</span>
                    </button>
                    <button type="button" className="cdm-btn cdm-btn-cancel" onClick={() => changeStatus(false)}>
                        <FiXCircle size={20} /><span>Cancelar</span>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ConfirmDeleteModal
